import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheWorldAwaits from "./sections/TheWorldAwaits";
import TheAotoStandard from "./sections/TheAotoStandard";
import IntegratedSolutions from "./sections/IntegratedSolutions";
import GlobalFootprintImpact from "./sections/GlobalFootprintImpact";
import StrategicAlliances from "./sections/StrategicAlliances";
import IndustryInsights from "./sections/IndustryInsights";
import StrategicRfqGateway from "./sections/StrategicRfqGateway";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheWorldAwaits />
      <TheAotoStandard />
      <IntegratedSolutions />
      <GlobalFootprintImpact />
      <StrategicAlliances />
      <IndustryInsights />
      <StrategicRfqGateway />
      <SecurityIntelligenceFooter />
    </div>;
}